// src/events/venue_booking_details.js
import React from "react";
import { FiCalendar, FiFilter, FiChevronRight } from "react-icons/fi";

const COLORS = {
  primary: "#f20c53",
  secondary: "#fb6c33",
  text: "#0f172a",
  subtext: "#475569",
  border: "#e2e8f0",
  page: "#f5f6f8",
  card: "#ffffff",
};

export default function VenueBookingDetails() {
  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gap: 16 }}>
      <section
        style={{
          background: COLORS.card,
          border: `1px solid ${COLORS.border}`,
          borderRadius: 14,
          boxShadow: "0 1px 2px rgba(0,0,0,.05)",
          padding: 16,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
          <div
            style={{
              width: 34,
              height: 34,
              display: "grid",
              placeItems: "center",
              borderRadius: 8,
              background: "#fff",
              border: `1px solid ${COLORS.border}`,
              color: COLORS.primary,
            }}
          >
            <FiCalendar />
          </div>
          <div style={{ fontWeight: 900, fontSize: 18, color: COLORS.text }}>
            Bookings (Dummy)
          </div>
        </div>

        {/* Filters row (dummy) */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr auto",
            gap: 10,
            marginBottom: 12,
          }}
        >
          <select style={inputStyle} defaultValue="all-venues" aria-label="Filter by venue">
            <option value="all-venues">All Venues</option>
          </select>
          <select style={inputStyle} defaultValue="all-status" aria-label="Filter by status">
            <option value="all-status">All Status</option>
            <option value="new">New</option>
            <option value="confirmed">Confirmed</option>
            <option value="cancelled">Cancelled</option>
          </select>
          <input type="date" style={inputStyle} aria-label="Filter by date" />
          <button type="button" style={ghostBtn}>
            <FiFilter /> Filter
          </button>
        </div>

        {/* Dummy list */}
        <div style={{ display: "grid", gap: 10 }}>
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                border: `1px solid ${COLORS.border}`,
                borderRadius: 12,
                padding: 12,
                display: "grid",
                gridTemplateColumns: "1fr auto",
                alignItems: "center",
                gap: 10,
              }}
            >
              <div>
                <div style={{ fontWeight: 800, color: COLORS.text }}>
                  Booking Request #{1000 + i}
                </div>
                <div style={{ fontSize: 13, color: COLORS.subtext, marginTop: 4 }}>
                  Venue: Sample Venue • Date: {`2025-10-0${i}`} • Slot: Half-day
                </div>
              </div>
              <button
                type="button"
                style={primaryBtn}
                onClick={() => {
                  // TODO: open booking detail
                }}
                aria-label={`View booking ${1000 + i}`}
              >
                View <FiChevronRight />
              </button>
            </div>
          ))}
        </div>

        {/* NOTE: Connect to live bookings later */}
      </section>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  height: 42,
  padding: "0 12px",
  border: `1px solid ${COLORS.border}`,
  borderRadius: 10,
  outline: "none",
  background: "#fff",
  color: COLORS.text,
  boxSizing: "border-box",
};

const primaryBtn = {
  height: 38,
  padding: "0 12px",
  borderRadius: 10,
  border: "none",
  color: "#fff",
  fontWeight: 800,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  background: `linear-gradient(90deg, ${COLORS.primary}, ${COLORS.secondary})`,
};

const ghostBtn = {
  height: 42,
  padding: "0 14px",
  borderRadius: 10,
  border: `1px solid ${COLORS.border}`,
  color: COLORS.text,
  background: "#fff",
  fontWeight: 700,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
};
